import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="centered">
      <div className="login-card">
        <div className="login-card__mark" aria-hidden="true" />
        <h1>404</h1>
        <p>La pagina che cercavi non esiste.</p>
        <Link to="/" className="btn btn--block">Torna alla home</Link>
      </div>
    </div>
  );
}
